import { useContext, useMemo } from "react";
import { UserContext } from "../amplify/authenticator-provider";
import { isAllLocationSelected } from "../library/helpers";

const useLocationHelpers = () => {
  const { user, isUserIsBeingSet } = useContext(UserContext);

  const currentLocationId = sessionStorage.getItem("currentLocationId");
  const isAllLocation = isAllLocationSelected();
  const isUserLoaded = !isUserIsBeingSet;

  const currentLocation = useMemo(() => {
    if (!user?.locations?.length || !currentLocationId) return null;

    if (isAllLocation) return null;

    return (
      user.locations.find(loc => String(loc.location?.id) === String(currentLocationId))
        ?.location || null
    );
  }, [user?.locations, currentLocationId, isAllLocation]);

  return {
    currentLocation,
    currentLocationId,
    isAllLocation,
    isUserLoaded,
  };
};

export default useLocationHelpers;
